export default [{
  path: '/marketsignup',
  name: 'marketsignup',
  meta: {
    title: '营销工具报名'
  },
  component: () =>
      import( /* webpackChunkName: "pop-reportList" */ '../views/marketsignup/index.vue')
},
{
  path: '/marketsignup/activityDetail',
  name: 'activityDetail',
  meta: {
    title: '营销工具报名详情'
  },
  component: () =>
    import( /* webpackChunkName: "pop-billDetails" */ '../views/marketsignup/activityDetail.vue')
}
]